import * as React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { thumbDiameter } from './Switch.overrides';
var CheckmarkIcon = function () { return (React.createElement("svg", { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
    React.createElement("path", { d: "M1 4L3 7L7 1", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };
var XIcon = function () { return (React.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
    React.createElement("path", { d: "M8.00424 2L2.00047 7.9962", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M2.00381 2L8.00381 8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        checked: {
            backgroundColor: theme.palette.success.main,
            // Needed for high contrast mode
            border: "1px solid ".concat(theme.palette.highContrastOnly.main),
            color: theme.palette.background.b1,
        },
        disabled: {
            // This uses a gradient with a hard edge instead of a 2px-wide border so
            // that it's not visible to high-constrast browsers.
            backgroundImage: "radial-gradient(".concat(theme.palette.background.b1, ", ").concat(theme.palette.background.b1, " ").concat(thumbDiameter / 2 - 2, "px, transparent ").concat(thumbDiameter / 2 - 2, "px, transparent)"),
            color: theme.palette.background.b7,
        },
        root: {
            alignItems: 'center',
            borderRadius: thumbDiameter / 2,
            display: 'flex',
            height: thumbDiameter,
            minHeight: thumbDiameter,
            minWidth: thumbDiameter,
            justifyContent: 'center',
            width: thumbDiameter,
        },
        unchecked: {
            backgroundColor: theme.palette.background.b8,
            // Needed for high contrast mode
            border: "1px solid ".concat(theme.palette.highContrastOnly.main),
            color: theme.palette.background.b1,
        },
    });
});
export var SwitchThumb = function (props) {
    var _a;
    var checked = props.checked, disabled = props.disabled;
    var classes = useStyles(props);
    return (React.createElement("div", { className: clsx(classes.root, (_a = {},
            _a[classes.checked] = !disabled && checked,
            _a[classes.disabled] = disabled,
            _a[classes.unchecked] = !disabled && !checked,
            _a)) }, checked ? React.createElement(CheckmarkIcon, null) : React.createElement(XIcon, null)));
};
//# sourceMappingURL=SwitchThumb.js.map